/* Presentation only: retain the app's customer data and commerce handlers. */
(() => {
  if (!/\/apps\/subscriptions\/?$/.test(location.pathname)) return;
  const market = window.MiraiMarket;
  const main = document.getElementById('MainContent');
  const title = main?.querySelector('h1');
  if (!title) return;
  const shell = title.parentElement;
  if (shell.classList.contains('mma')) return;
  document.body.classList.add('mirai-account-page');
  shell.classList.add('mma');
  const subscriptions = shell.querySelector('#sub-list');
  const header = document.createElement('header');
  header.className = 'mma-heading';
  const eyebrow = document.createElement('span');
  eyebrow.className = 'mma-eyebrow';
  eyebrow.textContent = 'YOUR SKINCARE, ALL TOGETHER';
  shell.prepend(header);
  header.append(eyebrow, title);
  title.textContent = 'My Mirai';
  const intro = shell.querySelector(':scope > p');
  if (intro) {
    intro.textContent = subscriptions ? 'Your everyday essentials. A little more rewarding.' : 'Sign in to manage your subscriptions and discover your rewards.';
    header.append(intro);
  }
  if (!subscriptions) { shell.classList.add('mma-signed-out'); window.MiraiLocalize?.(shell); return; }
  const nav = document.createElement('nav');
  nav.className = 'mma-nav';
  nav.setAttribute('aria-label', 'My Mirai');
  const accountUrl = document.querySelector('[data-mirai-account-url]')?.dataset.miraiAccountUrl || '/account';
  for (const [label, href] of [['Subscriptions', '#mirai-subscriptions'], ['Rewards', '#mirai-rewards'], ['Orders & account', accountUrl], ['Build my routine', '/pages/build-my-routine']]) {
    const a = document.createElement('a'); a.textContent = label; a.href = href.startsWith('/') ? market.url(href) : href; nav.append(a);
  }
  header.after(nav);
  const subSection = document.createElement('section');
  subSection.className = 'mma-subscriptions'; subSection.id = 'mirai-subscriptions';
  const subHeading = document.createElement('h2'); subHeading.textContent = 'Your subscriptions';
  subscriptions.before(subSection); subSection.append(subHeading, subscriptions);
  const loading = shell.querySelector('#sub-loading');
  if (loading) { loading.setAttribute('role', 'status'); subSection.append(loading); }
  subscriptions.querySelectorAll('select').forEach(s => s.setAttribute('aria-label', 'Change subscription frequency'));
  const rewardsHeading = [...shell.querySelectorAll('h2')].find(h => h.textContent.trim() === 'Mirai Rewards');
  if (!rewardsHeading) return;
  const rewards = rewardsHeading.parentElement;
  rewards.classList.add('mma-rewards'); rewards.id = 'mirai-rewards';
  const howHeading = [...rewards.querySelectorAll('h3')].find(h => h.textContent.includes('How Mirai Rewards works'));
  if (howHeading) {
    const content = howHeading.parentElement;
    const details = document.createElement('details'); details.className = 'mma-how';
    const summary = document.createElement('summary'); summary.textContent = howHeading.textContent;
    howHeading.remove(); content.before(details); details.append(summary, content); rewards.append(details);
  }
  const redeemHeading = [...rewards.querySelectorAll('h3')].find(h => h.textContent.trim() === 'Redeem Rewards');
  if (redeemHeading) {
    const section = redeemHeading.parentElement; section.classList.add('mma-redeem');
    const grid = redeemHeading.nextElementSibling; grid?.classList.add('mma-reward-grid');
    const tierSection = rewards.querySelector('.mirai-tier-grid')?.parentElement;
    if (tierSection) tierSection.before(section);
  }
  rewards.querySelector('#redeem-result')?.setAttribute('role', 'status');
  rewards.querySelectorAll('.mirai-tier-card').forEach(card => {
    const sync = () => {
      const flipped = card.classList.contains('flipped');
      card.setAttribute('aria-pressed', String(flipped));
      card.querySelector('.mirai-tier-front')?.setAttribute('aria-hidden', String(flipped));
      card.querySelector('.mirai-tier-back')?.setAttribute('aria-hidden', String(!flipped));
    };
    card.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
    });
    card.addEventListener('click', sync); sync();
  });
  window.MiraiLocalize?.(shell);
})();
